/* eslint-disable react/no-children-prop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-plusplus */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable no-unused-expressions */
import React, { Component } from 'react';
import moment from 'moment';
import {
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography
} from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { InfoOutlined, RemoveCircle } from '@mui/icons-material';
import { find, startCase } from 'lodash';

import FormContainer from '../../../FormContainer/FormContainer';
import {
  addAffiliatePayoutState,
  addPhonePayoutState,
  addThrottleState,
  editThrottleState,
  addAffiliatePayoutStateAdv,
  addAffiliatePayoutStateAdvCap
} from './defaultState/defaultState';
import { handleFormObjectChange } from '../../../Utilities/HandleFormObjectChange';
import { validateForSubmit } from '../../../Utilities/ValidationHelper/ValidateForm';
import { NetworkRequest } from '../../../Utilities/NetworkRequests/NetworkRequests';
import LoaderComponent from '../../../Utilities/LoaderComponent';
import { formatSubmitValues } from '../../../Utilities/SubmitHelper/FormatForSubmit';
import { buildFormFieldsWithStateForm } from '../../../Utilities/formHelper';
import { colors } from '../../../../Utilities/LenoxColors';
import WeightedForcedForms from '../WeightedForcedForms';
import AutomaticTesting from '../AutomaticTesting';
import Dialog from '../../../Dialog';

const styles = () => ({
  table: {
    width: '85%',
    margin: '1rem auto 1rem auto ',
    border: 'solid 1px rgba(0,0,0,0.2)'
  },
  tableContainer: {
    border: 'solid 1px rgba(20,20,20,.3)',
    borderRadius: '8px',
    margin: '1rem'
  },
  tableTitle: {
    fontSize: '1.25rem',
    textAlign: 'center',
    padding: '.5rem',
    backgroundColor: colors.lenoxDark2,
    color: colors.lenoxLight1,
    borderTopLeftRadius: '6px',
    borderTopRightRadius: '6px',
    marginBottom: '1rem'
  },
  phonePayoutMessage: {
    padding: '5% 10%',
    textAlign: 'center',
    color: 'rgba(0,0,0,0.54)',
    fontSize: 18
  }
});

const has = Object.prototype.hasOwnProperty;

export const siteToVertical = {
  2: 'auto',
  4: 'home',
  1: 'life',
  5: 'medicare',
  7: 'commercial',
  8: 'health',
  9: 'fe'
};

export const siteToLabel = {
  1: 'Life',
  2: 'Auto',
  4: 'Home',
  5: 'Medicare',
  6: 'Pet',
  7: 'Commercial',
  8: 'Health',
  9: 'Final Expense'
};

export const verticalToSite = {
  life: 1,
  auto: 2,
  home: 4,
  medicare: 5,
  pet: 6,
  commercial: 7,
  health: 8,
  fe: 9
};

const daysObj = {
  1: 'M',
  2: 'Tu',
  3: 'W',
  4: 'Th',
  5: 'F',
  6: 'Sa',
  7: 'Su'
};

class AffiliateSettings extends Component {
  state = {
    formValues: addAffiliatePayoutState(),
    formValuesAdv: addAffiliatePayoutStateAdv(),
    formValuesAdvCap: addAffiliatePayoutStateAdvCap(),
    formValuesS1: addAffiliatePayoutState(true),
    formValuesPhone: addPhonePayoutState(),
    formValuesAddThrottle: addThrottleState(),
    formValuesEditThrottle: editThrottleState(),
    submitting: false,
    loading: true,
    loadingAdv: true,
    loadingS1: true,
    loadingPhone: true,
    payouts: [],
    payoutsAdv: [],
    payoutsS1: [],
    phonePayouts: [],
    dialog: {
      message: '',
      type: 'error',
      title: 'Error'
    }
  };

  componentDidMount() {
    this.loadPayouts();
    this.loadPayoutsS1();
    this.loadAdvPayouts();
    this.loadPhonePayouts();
    if (this.props.row.throttle_id !== -1) {
      this.loadEditThrottleValues();
    }
  }

  loadPayouts = async () => {
    this.setState({ loading: true });
    const { data } = await NetworkRequest(
      'affiliateSpend',
      { affiliate_id: this.props.row.affiliate_id },
      'getAffiliateSpends'
    );
    this.setState(
      {
        payouts: data,
        loading: false
      },
      () => this.loadPayoutForm(this.state.payouts, false)
    );
  };

  loadPayoutsS1 = async () => {
    this.setState({ loadingS1: true });
    const { data } = await NetworkRequest(
      'affiliateSpendS1',
      { affiliate_id: this.props.row.affiliate_id },
      'getAffiliateSpends'
    );
    this.setState(
      {
        payoutsS1: data,
        loadingS1: false
      },
      () => this.loadPayoutForm(this.state.payoutsS1, true)
    );
  };

  loadAdvPayouts = async () => {
    this.setState({ loadingAdv: true });
    const { data } = await NetworkRequest(
      'affiliates',
      {
        affiliate_id: this.props.row.affiliate_id,
        vertical_id: this.state.formValuesAdv.site.value
      },
      'getAffiliateAdvancedPayouts'
    );
    this.setState({
      payoutsAdv: data,
      loadingAdv: false
    });
  };

  loadPhonePayouts = async () => {
    this.setState({ loadingPhone: true });
    const { data } = await NetworkRequest(
      'affiliates',
      { affiliate_id: this.props.row.affiliate_id },
      'getPhonePayouts'
    );
    this.setState(
      {
        phonePayouts: data,
        loadingPhone: false
      },
      () => this.loadPhonePayoutForm(this.state.phonePayouts)
    );
  };

  filterPayouts = (payouts, s1) => {
    const test = payouts.findIndex(
      (element) =>
        element.vertical ===
        siteToVertical[
          `${
            s1
              ? this.state.formValuesS1.site.value
              : this.state.formValues.site.value
          }`
        ]
    );
    if (test !== -1) {
      return payouts.filter(
        (element) =>
          element.vertical ===
          siteToVertical[
            `${
              s1
                ? this.state.formValuesS1.site.value
                : this.state.formValues.site.value
            }`
          ]
      );
    }
    s1
      ? this.setState({
          formValuesS1: addAffiliatePayoutState(
            true,
            this.state.formValuesS1.site.value
          )
        })
      : this.setState({
          formValues: addAffiliatePayoutState(
            false,
            this.state.formValues.site.value
          )
        });
  };

  filterPhonePayouts = (payouts) => {
    const test = payouts.findIndex(
      (element) =>
        element.vertical ===
        siteToVertical[`${this.state.formValuesPhone.site_id.value}`]
    );
    if (test !== -1) {
      return payouts.filter(
        (element) =>
          element.vertical ===
          siteToVertical[`${this.state.formValuesPhone.site_id.value}`]
      );
    }
    this.setState({
      formValuesPhone: addPhonePayoutState(
        this.state.formValuesPhone.site_id.value
      )
    });
  };

  loadPayoutForm = (payouts, s1 = false) => {
    if (payouts && payouts.length > 0) {
      const filteredPayouts = this.filterPayouts(payouts, s1);
      if (filteredPayouts && filteredPayouts.length > 0) {
        const mobilePeak = find(filteredPayouts, {
          device: 'mobile',
          peak_hours: 'Peak'
        });
        const desktopPeak = find(filteredPayouts, {
          device: 'desktop',
          peak_hours: 'Peak'
        });
        let mobileOffPeak = null;
        let desktopOffPeak = null;
        if (filteredPayouts[0].affiliate_type === '1') {
          mobileOffPeak = find(filteredPayouts, {
            device: 'mobile',
            peak_hours: 'Off Peak'
          });
          desktopOffPeak = find(filteredPayouts, {
            device: 'desktop',
            peak_hours: 'Off Peak'
          });
        }
        this.setState(
          ({ [s1 ? 'formValuesS1' : 'formValues']: formValues }) => {
            const newStateValues = {
              [s1 ? 'formValuesS1' : 'formValues']: {
                ...formValues,
                step: {
                  ...formValues.step,
                  value: filteredPayouts[0].step
                },
                affiliate_type: {
                  ...formValues.affiliate_type,
                  value: filteredPayouts[0].affiliate_type
                },
                is_revshare: {
                  ...formValues.is_revshare,
                  value: filteredPayouts[0].is_revshare
                },
                desktop_payout: {
                  ...formValues.desktop_payout,
                  value: desktopPeak ? desktopPeak.spend : '10'
                },
                mobile_payout: {
                  ...formValues.mobile_payout,
                  value: mobilePeak ? mobilePeak.spend : '10'
                },
                off_peak_desktop: {
                  ...formValues.off_peak_desktop,
                  value: desktopOffPeak ? desktopOffPeak.spend : '5'
                },
                off_peak_mobile: {
                  ...formValues.off_peak_mobile,
                  value: mobileOffPeak ? mobileOffPeak.spend : '5'
                }
              }
            };
            if (s1) {
              newStateValues.formValuesS1.s1 = {
                ...formValues.s1,
                value: filteredPayouts[0].s1
              };
            }
            return newStateValues;
          },
          () => {
            this.setState(
              {
                [s1 ? 'formValuesS1' : 'formValues']: this.handleRevshareChange(
                  'is_revshare',
                  filteredPayouts[0].is_revshare,
                  this.state[s1 ? 'formValuesS1' : 'formValues'],
                  true
                )
              },
              () =>
                s1
                  ? this.handleHiddenFieldsS1(this.showExternalFields(true))
                  : this.handleHiddenFields(this.showExternalFields())
            );
          }
        );
      }
    }
  };

  loadPhonePayoutForm = (payouts) => {
    if (payouts && payouts.length > 0) {
      const filteredPayouts = this.filterPhonePayouts(payouts);
      if (filteredPayouts && filteredPayouts.length > 0) {
        this.setState(
          ({ formValuesPhone: formValues }) => {
            return {
              formValuesPhone: {
                ...formValues,
                is_revshare: {
                  ...formValues.is_revshare,
                  value: !!+filteredPayouts[0].is_revshare
                },
                payout: {
                  ...formValues.payout,
                  value: filteredPayouts[0].payout
                    ? filteredPayouts[0].payout
                    : '10'
                }
              }
            };
          },
          () => {
            this.setState({
              formValuesPhone: this.handleRevsharePhoneChange(
                'is_revshare',
                !!+filteredPayouts[0].is_revshare,
                this.state.formValuesPhone,
                true,
                true
              )
            });
          }
        );
      }
    }
  };

  removePayout = async (id, s1) => {
    const { data } = await NetworkRequest(
      s1 ? 'affiliateSpendS1' : 'affiliateSpend',
      { id },
      'delete'
    );
    if (data) {
      this.removePayoutRow(id, s1);
    }
  };

  removePayoutAdv = async (id) => {
    const {
      row: { affiliate_id }
    } = this.props;
    const { data } = await NetworkRequest(
      'affiliates',
      {
        id,
        affiliate_id,
        vertical_id: this.state.formValuesAdv.site.value
      },
      'deleteAffiliateAdvancedPayouts'
    );
    if (data) {
      this.removePayoutRowAdv(id);
    }
  };

  removePhonePayout = async (id) => {
    const { data } = await NetworkRequest(
      'affiliates',
      { id },
      'removePhonePayout'
    );
    if (data && data.success) {
      this.removePhonePayoutRow(id);
    }
  };

  removePayoutRow = (id, s1) =>
    this.setState(({ [s1 ? 'payoutsS1' : 'payouts']: payouts }) => {
      const newPayouts = payouts
        .map((payout) => {
          if (payout.id === id) {
            return null;
          }
          return payout;
        })
        .filter((i) => i);
      return { [s1 ? 'payoutsS1' : 'payouts']: newPayouts };
    });

  removePayoutRowAdv = (id) => {
    const { payoutsAdv } = this.state;
    const newPayouts = {
      payouts: payoutsAdv.payouts.map((payout) => ({
        state: payout.state,
        dayParts: payout.dayParts.filter((i) => i.id !== id)
      })),
      cap: payoutsAdv.cap?.filter((i) => i.id !== id) || []
    };
    this.setState({ payoutsAdv: newPayouts });
  };

  removePhonePayoutRow = (id) =>
    this.setState(({ phonePayouts: payouts }) => {
      const newPayouts = payouts
        .map((payout) => {
          if (payout.id === id) {
            return null;
          }
          return payout;
        })
        .filter((i) => i);
      return { phonePayouts: newPayouts };
    });

  handleRevsharePayoutChange = (
    value,
    formValues,
    name,
    load,
    phone = false
  ) => {
    const newValues = {
      ...formValues,
      adornment: value ? '%' : '$',
      adornmentPosition: value ? 'end' : 'start'
    };
    if (!load) {
      newValues[value] = value
        ? ''
        : phone
        ? addPhonePayoutState()[name].value || ''
        : addAffiliatePayoutState()[name].value || '';
    }
    return newValues;
  };

  handleRevshareChange = (field, value, formValues, load = false) => {
    if (field === 'is_revshare') {
      return {
        ...formValues,
        off_peak_desktop: this.handleRevsharePayoutChange(
          value,
          formValues.off_peak_desktop,
          'off_peak_desktop',
          load
        ),
        off_peak_mobile: this.handleRevsharePayoutChange(
          value,
          formValues.off_peak_mobile,
          'off_peak_mobile',
          load
        ),
        desktop_payout: this.handleRevsharePayoutChange(
          value,
          formValues.desktop_payout,
          'desktop_payout',
          load
        ),
        mobile_payout: this.handleRevsharePayoutChange(
          value,
          formValues.mobile_payout,
          'mobile_payout',
          load
        )
      };
    }
    return formValues;
  };

  handleRevsharePhoneChange = (field, value, formValues, load = false) => {
    if (field === 'is_revshare') {
      return {
        ...formValues,
        payout: this.handleRevsharePayoutChange(
          value,
          formValues.payout,
          'payout',
          load,
          true
        )
      };
    }
    return formValues;
  };

  handleChange = (field, value) => {
    let formValues = handleFormObjectChange(field, value, {
      ...this.state.formValues
    });
    formValues = this.handleRevshareChange(field, value, { ...formValues });
    this.setState({ formValues });
    this.handleHiddenFields(this.showExternalFields());
    if (field === 'site') {
      this.loadPayoutForm(this.state.payouts, false);
    }
  };

  handleChangeS1 = (field, value) => {
    let formValuesS1 = handleFormObjectChange(field, value, {
      ...this.state.formValuesS1
    });
    formValuesS1 = this.handleRevshareChange(field, value, { ...formValuesS1 });
    this.setState({ formValuesS1 });
    this.handleHiddenFieldsS1(this.showExternalFields(true));
    if (field === 'site') {
      this.loadPayoutForm(this.state.payoutsS1, true);
    }
  };

  handleChangePhone = (field, value) => {
    let formValuesPhone = handleFormObjectChange(field, value, {
      ...this.state.formValuesPhone
    });
    formValuesPhone = this.handleRevsharePhoneChange(field, value, {
      ...formValuesPhone
    });
    this.setState({ formValuesPhone });
    if (field === 'site_id') {
      this.loadPhonePayoutForm(this.state.phonePayouts);
    }
  };

  handleChangeAdv = (field, value) => {
    const formValuesAdv = handleFormObjectChange(field, value, {
      ...this.state.formValuesAdv
    });
    this.setState({ formValuesAdv });
    if (field === 'site') {
      const formValuesAdvCap = handleFormObjectChange(field, value, {
        ...this.state.formValuesAdvCap
      });
      this.setState({ formValuesAdvCap });
      this.loadAdvPayouts();
    }
  };

  handleChangeAdvCap = (field, value) => {
    const formValuesAdvCap = handleFormObjectChange(field, value, {
      ...this.state.formValuesAdvCap
    });
    this.setState({ formValuesAdvCap });
    if (field === 'site') {
      const formValuesAdv = handleFormObjectChange(field, value, {
        ...this.state.formValuesAdv
      });
      this.setState({ formValuesAdv });
      this.loadAdvPayouts();
    }
  };

  handleChangeAddT = (field, value) => {
    const formValuesAddThrottle = handleFormObjectChange(field, value, {
      ...this.state.formValuesAddThrottle
    });
    this.setState({ formValuesAddThrottle });
  };

  handleChangeEditT = (field, value) => {
    const formValuesEditThrottle = handleFormObjectChange(field, value, {
      ...this.state.formValuesEditThrottle
    });
    this.setState({ formValuesEditThrottle });
  };

  handleHiddenFields = (showExternal) =>
    this.setState(({ formValues }) => ({
      formValues: this.modifyHiddenFields(formValues, !showExternal)
    }));

  handleHiddenFieldsS1 = (showExternal) =>
    this.setState(({ formValuesS1 }) => ({
      formValuesS1: this.modifyHiddenFields(formValuesS1, !showExternal)
    }));

  modifyHiddenFields = (formValues, hideExternal) => ({
    ...formValues,
    off_peak_desktop: {
      ...formValues.off_peak_desktop,
      hidden: hideExternal
    },
    off_peak_mobile: {
      ...formValues.off_peak_mobile,
      hidden: hideExternal
    }
  });

  toggleDialog = (message = '', type = 'error', title = 'Error') =>
    this.setState({
      dialog: { ...this.state.dialog, message, type, title }
    });

  handleSubmit = () => {
    const { valid, messages } = validateForSubmit(this.state.formValues);
    if (!valid) {
      this.toggleDialog(messages, 'error');
      return;
    }
    this.handleSubmitRequest(
      'affiliateSpend',
      'addAffSpend',
      this.state.formValues
    );
  };

  handleSubmitS1 = () => {
    const { valid, messages } = validateForSubmit(this.state.formValuesS1);
    if (!valid) {
      this.toggleDialog(messages, 'error');
      return;
    }
    this.handleSubmitRequest(
      'affiliateSpendS1',
      'addAffSpend',
      this.state.formValuesS1
    );
  };

  handleSubmitAdv = () => {
    const { valid, messages } = validateForSubmit(this.state.formValuesAdv);
    if (!valid) {
      this.toggleDialog(messages, 'error');
      return;
    }
    this.handleAdvSubmitRequest(
      'affiliates',
      'addAffiliateAdvancedPayouts',
      this.state.formValuesAdv,
      false
    );
  };

  timeToInt = (time) => {
    const [hours, minutes] = time.split(':');
    return parseInt(hours, 10) * 60 + parseInt(minutes, 10);
  };

  checkOverlapping = (a, b) => {
    return a.start < b.end && b.start < a.end;
  };

  checkConflicts = (payouts, newPayout, cap) => {
    if (!payouts || payouts.length === 0) {
      return false;
    }
    for (let i = 0; i < payouts.length; i++) {
      if (payouts[i].state === newPayout.state || cap) {
        for (
          let j = 0;
          cap ? j < payouts.length : j < payouts[i].dayParts.length;
          j++
        ) {
          const existingDayPart = cap ? payouts[i] : payouts[i].dayParts[j];
          existingDayPart.start = this.timeToInt(existingDayPart.start_time);
          existingDayPart.end = this.timeToInt(existingDayPart.end_time);
          let newDayPart;
          if (cap) {
            newDayPart = {
              start_time: newPayout.start_time,
              end_time: newPayout.end_time,
              cap: newPayout.cap,
              days: newPayout.days,
              start: this.timeToInt(newPayout.start_time),
              end: this.timeToInt(newPayout.end_time)
            };
          } else {
            newDayPart = {
              start_time: newPayout.dayPart.start_time,
              end_time: newPayout.dayPart.end_time,
              payout: newPayout.dayPart.payout,
              days: newPayout.dayPart.days,
              start: this.timeToInt(newPayout.dayPart.start_time),
              end: this.timeToInt(newPayout.dayPart.end_time)
            };
          }

          for (const day of existingDayPart.days) {
            if (
              newDayPart.days.includes(day) &&
              this.checkOverlapping(existingDayPart, newDayPart)
            ) {
              return true;
            }
          }
        }
      }
    }

    return false;
  };

  handleSubmitAdvCap = () => {
    const { valid, messages } = validateForSubmit(this.state.formValuesAdvCap);
    if (!valid) {
      this.toggleDialog(messages, 'error');
      return;
    }
    this.handleAdvSubmitRequest(
      'affiliates',
      'addAffiliateAdvancedPayouts',
      this.state.formValuesAdvCap,
      true
    );
  };

  handleSubmitPhone = () => {
    const { formValuesPhone } = this.state;
    const { valid, messages } = validateForSubmit(formValuesPhone);
    if (!valid) {
      this.toggleDialog(messages, 'error');
      return;
    }
    const formattedSubmitValues = formatSubmitValues(formValuesPhone);
    this.setState({ submitting: true }, () =>
      NetworkRequest(
        'affiliates',
        { ...formattedSubmitValues, affiliate_id: this.props.row.affiliate_id },
        'addPhonePayout'
      )
        .then(({ data }) =>
          this.handleResponse(data, formValuesPhone, false, false)
        )
        .then(() => this.loadPhonePayouts())
        .catch(() => this.setState({ submitting: false }))
    );
  };

  handleSubmitRequest = (endpoint, action, formValues) => {
    const formattedSubmitValues = formatSubmitValues(formValues);
    this.setState({ submitting: true }, () =>
      NetworkRequest(
        endpoint,
        {
          ...formattedSubmitValues,
          affiliateID: this.props.row.affiliate_id,
          id: this.props.row.throttle_id
        },
        action
      )
        .then(({ data }) =>
          this.handleResponse(
            data,
            formValues,
            (endpoint === 'affiliateSpend' ||
              endpoint === 'affiliateSpendS1') &&
              action === 'addAffSpend',
            action === 'addThrottle'
          )
        )
        .catch(() => this.setState({ submitting: false }))
    );
  };

  handleAdvSubmitRequest = (endpoint, action, formValues, cap) => {
    const formattedSubmitValues = formatSubmitValues(formValues);
    let config;

    if (cap) {
      config = {
        start_time: moment(formattedSubmitValues.start_time, 'HH:mm:ss').format(
          'HH:mm'
        ),
        end_time: moment(formattedSubmitValues.end_time, 'HH:mm:ss').format(
          'HH:mm'
        ),
        days: formattedSubmitValues.days,
        cap: Number(formattedSubmitValues.cap)
      };
    } else {
      config = {
        state: formattedSubmitValues.state,
        dayPart: {
          start_time: moment(
            formattedSubmitValues.start_time,
            'HH:mm:ss'
          ).format('HH:mm'),
          end_time: moment(formattedSubmitValues.end_time, 'HH:mm:ss').format(
            'HH:mm'
          ),
          days: formattedSubmitValues.days,
          payout: formattedSubmitValues.payout
        }
      };
    }
    const conflicts = this.checkConflicts(
      cap ? this.state.payoutsAdv.cap : this.state.payoutsAdv.payouts,
      config,
      cap
    );

    if (conflicts) {
      this.toggleDialog(
        `There is a conflict in the provided ${
          cap ? 'cap' : 'payout'
        } schedule. The new ${
          cap ? 'cap' : 'payout'
        } overlaps with an existing ${cap ? 'cap' : 'payout'} ${
          cap ? 'for the same days' : 'for the same state and days'
        }. Please adjust the start and end times to avoid overlapping time intervals.`,
        'error',
        'Error'
      );
      return;
    }

    this.setState({ submitting: true }, () =>
      NetworkRequest(
        endpoint,
        {
          config,
          affiliate_id: this.props.row.affiliate_id,
          vertical_id: formattedSubmitValues.site
        },
        action
      )
        .then(({ data }) =>
          this.setState({ submitting: false }, () => {
            this.loadAdvPayouts();
            this.toggleDialog(
              data.message,
              data.success ? 'success' : 'error',
              data.success ? 'Success' : 'Error'
            );
          })
        )
        .catch(() => this.setState({ submitting: false }))
    );
  };

  handleSubmitAddThrottle = () => {
    const { valid, messages } = validateForSubmit(
      this.state.formValuesAddThrottle
    );
    if (!valid) {
      this.toggleDialog(messages, 'error');
      return false;
    }
    this.handleSubmitRequest(
      'throttle',
      'addThrottle',
      this.state.formValuesAddThrottle
    );
  };

  handleSubmitEditThrottle = () => {
    const { valid, messages } = validateForSubmit(
      this.state.formValuesEditThrottle
    );
    if (!valid) {
      this.toggleDialog(messages, 'error');
      return false;
    }
    this.handleSubmitRequest(
      'throttle',
      'updateThrottle',
      this.state.formValuesEditThrottle
    );
  };

  handleResponse = (
    data,
    formValues = null,
    loadPy = false,
    addedThrottle = false
  ) => {
    this.setState({ submitting: false }, () => {
      this.toggleDialog(
        data.message,
        data.success ? 'success' : 'error',
        data.success ? 'Success' : 'Error'
      );
      (loadPy && this.loadPayouts() && this.loadPayoutsS1()) ||
        Object.keys(formValues).forEach((key) =>
          this.props.onChange(this.props.row, key, formValues[key].value)
        );
      if (addedThrottle && has.call(data, 'id')) {
        this.props.onChange(this.props.row, 'throttle_id', data.id);
        this.loadEditThrottleValues();
      }
    });
  };

  loadEditThrottleValues = () => {
    const {
      formValuesEditThrottle: { site, throttle_percentage, throttle_status }
    } = this.state;
    this.setState({
      formValuesEditThrottle: {
        ...this.state.formValuesEditThrottle,
        site: {
          ...site,
          value: this.props.row.site
        },
        throttle_percentage: {
          ...throttle_percentage,
          value: this.props.row.throttle_percentage
        },
        throttle_status: {
          ...throttle_status,
          value:
            (this.props.row.throttle_status ||
              this.props.row.throttle_status === '1') > 0
              ? '1'
              : '0'
        }
      }
    });
  };

  showExternalFields = (s1 = false) =>
    this.state[s1 ? 'formValuesS1' : 'formValues'].affiliate_type.value === '1';

  renderRemoveCell = (id, s1, phone = false) => (
    <IconButton
      onClick={() =>
        phone ? this.removePhonePayout(id) : this.removePayout(id, s1)
      }
      size="large"
    >
      <RemoveCircle />
    </IconButton>
  );

  renderRemoveCellAdv = (id) => (
    <IconButton onClick={() => this.removePayoutAdv(id)} size="large">
      <RemoveCircle />
    </IconButton>
  );

  renderRow = (vertical, step, device, peakHours, payout, remove) => (
    <TableRow>
      <TableCell align="left">{vertical}</TableCell>
      <TableCell align="left">{step}</TableCell>
      <TableCell align="right">{device}</TableCell>
      <TableCell align="right">{peakHours}</TableCell>
      <TableCell align="right">{payout}</TableCell>
      <TableCell align="right">{remove}</TableCell>
    </TableRow>
  );

  renderS1Row = (vertical, step, device, peakHours, payout, sub, remove) => (
    <TableRow>
      <TableCell align="left">{vertical}</TableCell>
      <TableCell align="left">{step}</TableCell>
      <TableCell align="right">{device}</TableCell>
      <TableCell align="right">{peakHours}</TableCell>
      <TableCell align="right">{payout}</TableCell>
      <TableCell align="right">{sub}</TableCell>
      <TableCell align="right">{remove}</TableCell>
    </TableRow>
  );

  renderAdvRow = (state, dayParts) => {
    return (
      <>
        <TableRow>
          <TableCell align="left">{state}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <Table aria-label="payouts">
              <TableHead>
                <TableRow>
                  <TableCell>Days</TableCell>
                  <TableCell>Start Time</TableCell>
                  <TableCell>End Time</TableCell>
                  <TableCell>Payout</TableCell>
                  <TableCell align="right">Remove</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dayParts &&
                  dayParts.length > 0 &&
                  dayParts.map(({ days, start_time, end_time, payout, id }) => (
                    <TableRow>
                      <TableCell align="left" width="40%">
                        <span>
                          {Object.keys(daysObj).map((day) => (
                            <div
                              style={{
                                border: '1px solid black',
                                display: 'inline-block',
                                marginRight: '3px',
                                fontFamily: 'Times',
                                textAlign: 'center',
                                fontSize: '1rem',
                                width: '20px',
                                height: '20px',
                                lineHeight: '20px',
                                padding: '1px',
                                backgroundColor: days.includes(Number(day))
                                  ? '#00FF00'
                                  : '#DCDCDC'
                              }}
                            >
                              {daysObj[day]}
                            </div>
                          ))}
                        </span>
                      </TableCell>
                      <TableCell>
                        {moment(start_time, 'HH:mm:ss').format('hh:mm A')}
                      </TableCell>
                      <TableCell>
                        {moment(end_time, 'HH:mm:ss').format('hh:mm A')}
                      </TableCell>
                      <TableCell>${Number(payout).toFixed(2)}</TableCell>
                      <TableCell align="right">
                        {this.renderRemoveCellAdv(id)}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableCell>
        </TableRow>
      </>
    );
  };

  renderPhoneRow = (vertical, payout, remove) => (
    <TableRow>
      <TableCell align="left">{vertical}</TableCell>
      <TableCell align="right">{payout}</TableCell>
      <TableCell align="right">{remove}</TableCell>
    </TableRow>
  );

  renderDateTable = (payouts, s1 = false) =>
    payouts.length > 0 && (
      <Grid item className={this.props.classes.tableContainer}>
        <div className={this.props.classes.tableTitle}>
          Existing Payouts {s1 ? 'S1' : ''}
        </div>
        <Table className={this.props.classes.table}>
          <TableHead>
            {s1 &&
              this.renderS1Row(
                'Vertical',
                'Step',
                'Device',
                'Peak Hours',
                'Payout',
                'S1',
                'Remove'
              )}
            {!s1 &&
              this.renderRow(
                'Vertical',
                'Step',
                'Device',
                'Peak Hours',
                'Payout',
                'Remove'
              )}
          </TableHead>
          <TableBody>
            {s1 &&
              payouts.map(
                ({
                  vertical,
                  step,
                  device,
                  peak_hours,
                  spend,
                  id,
                  is_revshare,
                  s1: sub
                }) =>
                  this.renderS1Row(
                    startCase(vertical),
                    startCase(step),
                    startCase(device),
                    startCase(peak_hours),
                    !is_revshare ? `$${spend}` : `${spend}%`,
                    sub,
                    this.renderRemoveCell(id, s1)
                  )
              )}
            {!s1 &&
              payouts.map(
                ({
                  vertical,
                  step,
                  device,
                  peak_hours,
                  spend,
                  id,
                  is_revshare
                }) =>
                  this.renderRow(
                    startCase(vertical),
                    startCase(step),
                    startCase(device),
                    startCase(peak_hours),
                    !is_revshare ? `$${spend}` : `${spend}%`,
                    this.renderRemoveCell(id, s1)
                  )
              )}
          </TableBody>
        </Table>
      </Grid>
    );

  renderAdvDateTable = (advPayoutState) => {
    return (
      <Grid item className={this.props.classes.tableContainer}>
        <div className={this.props.classes.tableTitle}>
          Existing Advanced Payouts & Caps
        </div>
        {advPayoutState && Object.keys(advPayoutState).length > 0 ? (
          <>
            {advPayoutState.payouts && advPayoutState.payouts.length > 0 && (
              <Table className={this.props.classes.table}>
                <TableHead>
                  <TableCell align="left">State</TableCell>
                </TableHead>
                <TableBody>
                  {advPayoutState.payouts.map(
                    ({ state, dayParts }) =>
                      dayParts.length > 0 &&
                      dayParts &&
                      this.renderAdvRow(startCase(state), dayParts)
                  )}
                </TableBody>
              </Table>
            )}
            {advPayoutState.cap && advPayoutState.cap.length > 0 && (
              <Table className={this.props.classes.table}>
                <TableHead>
                  <TableCell align="left">Caps</TableCell>
                </TableHead>
                <TableBody align="center">
                  <TableHead>
                    <TableRow>
                      <TableCell>Days</TableCell>
                      <TableCell>Start Time</TableCell>
                      <TableCell>End Time</TableCell>
                      <TableCell>Cap</TableCell>
                      <TableCell align="right">Remove</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {advPayoutState.cap.map(
                      ({ days, start_time, end_time, cap, id }) => (
                        <TableRow>
                          <TableCell align="left" width="40%">
                            <span>
                              {Object.keys(daysObj).map((day) => (
                                <div
                                  style={{
                                    border: '1px solid black',
                                    display: 'inline-block',
                                    marginRight: '3px',
                                    fontFamily: 'Times',
                                    textAlign: 'center',
                                    fontSize: '1rem',
                                    width: '20px',
                                    height: '20px',
                                    lineHeight: '20px',
                                    padding: '1px',
                                    backgroundColor: days.includes(Number(day))
                                      ? '#00FF00'
                                      : '#DCDCDC'
                                  }}
                                >
                                  {daysObj[day]}
                                </div>
                              ))}
                            </span>
                          </TableCell>
                          <TableCell>
                            {moment(start_time, 'HH:mm:ss').format('hh:mm A')}
                          </TableCell>
                          <TableCell>
                            {moment(end_time, 'HH:mm:ss').format('hh:mm A')}
                          </TableCell>
                          <TableCell>{cap}</TableCell>
                          <TableCell align="right">
                            {this.renderRemoveCellAdv(id)}
                          </TableCell>
                        </TableRow>
                      )
                    )}
                  </TableBody>
                </TableBody>
              </Table>
            )}
          </>
        ) : (
          <div className={this.props.classes.phonePayoutMessage}>
            No advanced payouts & caps are currently setup.
          </div>
        )}
      </Grid>
    );
  };

  renderPhoneTable = (payouts) => (
    <Grid item className={this.props.classes.tableContainer}>
      <div className={this.props.classes.tableTitle}>
        Existing Phone Payouts
      </div>
      {payouts.length > 0 ? (
        <Table className={this.props.classes.table}>
          <TableHead>
            {this.renderPhoneRow('Vertical', 'Payout', 'Remove')}
          </TableHead>
          <TableBody>
            {payouts.map(({ vertical, payout, id, is_revshare }) =>
              this.renderPhoneRow(
                startCase(vertical),
                !+is_revshare ? `$${payout}` : `${payout}%`,
                this.renderRemoveCell(id, false, true)
              )
            )}
          </TableBody>
        </Table>
      ) : (
        <div className={this.props.classes.phonePayoutMessage}>
          No phone payouts are currently setup.
        </div>
      )}
    </Grid>
  );

  renderFormContainer = (
    formValues,
    handleSubmitFunc,
    handleChange,
    submitting,
    title,
    tooltip = ''
  ) => (
    <Grid item className={this.props.classes.tableContainer}>
      <div className={this.props.classes.tableTitle}>
        {title}
        {tooltip.length > 0 ? (
          <Tooltip title={tooltip} placement="bottom">
            <InfoOutlined style={{ height: '.7em' }} />
          </Tooltip>
        ) : (
          ''
        )}
      </div>
      <FormContainer
        formValues={buildFormFieldsWithStateForm(formValues, formValues)}
        submitting={submitting}
        handleChange={handleChange}
        handleSubmit={handleSubmitFunc}
        inputWidth={8}
        separateBlock
        toggleDialog={this.toggleDialog}
        caption="testing"
      />
    </Grid>
  );

  renderWeightedForcedForm = () => (
    <WeightedForcedForms row={this.props.row} onChange={this.updateRow} />
  );

  renderAutomaticTestingForm = () => (
    <AutomaticTesting row={this.props.row} onChange={this.props.onChange} />
  );

  render() {
    const {
      formValues,
      formValuesS1,
      formValuesAdv,
      formValuesPhone,
      formValuesAddThrottle,
      formValuesEditThrottle,
      formValuesAdvCap,
      submitting,
      dialog,
      payouts,
      payoutsS1,
      payoutsAdv,
      loading,
      loadingS1,
      loadingPhone,
      phonePayouts,
      loadingAdv
    } = this.state;
    return (
      <>
        <Typography align="left" variant="caption" style={{ margin: '1rem' }}>
          Changing payouts will replace the current affiliate's payout.
        </Typography>
        {loading ? (
          <LoaderComponent padding={150} />
        ) : (
          this.renderFormContainer(
            formValues,
            this.handleSubmit,
            this.handleChange,
            submitting,
            'Payout'
          )
        )}
        {loading ? (
          <LoaderComponent padding={150} />
        ) : (
          this.renderDateTable(payouts)
        )}
        {loadingAdv ? (
          <LoaderComponent padding={150} />
        ) : (
          this.renderFormContainer(
            formValuesAdv,
            this.handleSubmitAdv,
            this.handleChangeAdv,
            submitting,
            'Advanced Payouts',
            'Activity outside of day parting windows will not be paid when using this feature.'
          )
        )}
        {loadingAdv ? (
          <LoaderComponent padding={150} />
        ) : (
          this.renderFormContainer(
            formValuesAdvCap,
            this.handleSubmitAdvCap,
            this.handleChangeAdvCap,
            submitting,
            'Advanced Caps',
            'Any leads generated outside of these hours will not be capped.'
          )
        )}
        {loadingAdv ? (
          <LoaderComponent padding={150} />
        ) : (
          this.renderAdvDateTable(payoutsAdv)
        )}
        {loadingS1 ? (
          <LoaderComponent padding={150} />
        ) : (
          this.renderFormContainer(
            formValuesS1,
            this.handleSubmitS1,
            this.handleChangeS1,
            submitting,
            'Payout S1',
            'Advanced Payouts & Caps will override s1 Payouts'
          )
        )}
        {loadingS1 ? (
          <LoaderComponent padding={150} />
        ) : (
          this.renderDateTable(payoutsS1, true)
        )}
        {loadingPhone ? (
          <LoaderComponent padding={150} />
        ) : (
          this.renderFormContainer(
            formValuesPhone,
            this.handleSubmitPhone,
            this.handleChangePhone,
            submitting,
            'Phone Payout'
          )
        )}
        {loadingPhone ? (
          <LoaderComponent padding={150} />
        ) : (
          this.renderPhoneTable(phonePayouts)
        )}
        {this.props.row.throttle_id === -1
          ? this.renderFormContainer(
              formValuesAddThrottle,
              this.handleSubmitAddThrottle,
              this.handleChangeAddT,
              submitting,
              'Add Throttle'
            )
          : this.renderFormContainer(
              formValuesEditThrottle,
              this.handleSubmitEditThrottle,
              this.handleChangeEditT,
              submitting,
              'Edit Throttle'
            )}
        {this.renderWeightedForcedForm()}
        {this.renderAutomaticTestingForm()}

        {!!dialog && (
          <Dialog
            title={dialog.title || 'Error'}
            children={dialog.message}
            open={!!dialog.message}
            onRequestClose={() =>
              this.toggleDialog('', dialog.type, dialog.title)
            }
            type={dialog.type}
          />
        )}
      </>
    );
  }
}

export default withStyles(AffiliateSettings, styles);
